module.exports = __webpack_public_path__ + "static/media/md-thunderstorm.049188c8.svg";